export default __webpack_public_path__ + "static/media/spotlight-header-bg.e4ddbbac.png";